import { UploadManyFonts, UploadOneFont } from "@/interfaces/font.interface";
import fontApi from "@/api/font";
import storageApi from "@/api/storage";
import { getFileNameWithoutExt, naturalSortFileList } from "./common";
import pLimit from "p-limit";
import { v4 } from "uuid";

const BASE_PATH = "library/fonts";
const CONCURRENCY = 2;

export const uploadManyFonts = async (
  fontFiles: File[],
  categoryId?: string,
  onProgress?: (data: string) => void,
) => {
  const files = naturalSortFileList(fontFiles);
  const items: UploadOneFont[] = [];
  const limiter = pLimit(CONCURRENCY);
  const uploadProcesses: Promise<string | undefined>[] = [];
  const successfulUploads: UploadOneFont[] = [];

  let progress = 0;
  onProgress?.(`(${progress}/${files.length})`);
  files.forEach((file) => {
    const [, ext] = file.type.split("/");
    const filePath = BASE_PATH;
    const fileName = `${v4()}.${ext}`;
    const data = {
      name: getFileNameWithoutExt(file.name),
      s3Path: `${filePath}/${fileName}`,
      relativePath: file.webkitRelativePath,
    };
    items.push(data);
    uploadProcesses.push(
      limiter(() =>
        storageApi
          .uploadFile(file, filePath, fileName, `font/${ext}`)
          .then((url) => {
            if (url) {
              progress += 1;
              onProgress?.(`(${progress}/${files.length})`);
              successfulUploads.push(data);
            }
            return url;
          }),
      ),
    );
  });

  await Promise.all(uploadProcesses);

  const payload: UploadManyFonts = { categoryId, items };
  try {
    await fontApi.uploadMany(payload);
    return successfulUploads;
  } catch (error) {
    console.log(error);
    return successfulUploads;
  }
};
